import SFetch from '@app/utils/sfetch'

export default {
  getUsers() {
    const url = Silverfin.Routes.company_users_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId
    )

    return SFetch.json(url, { method: 'GET' })
  },

  createUsers(usersData) {
    const url = Silverfin.Routes.company_users_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId
    )

    return SFetch.json(url, {
      method: 'POST',
      body: { users: usersData },
    })
  },

  updateUser(id, data) {
    const url = Silverfin.Routes.company_user_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      id
    )

    return SFetch.json(url, {
      method: 'PATCH',
      body: { user: { ...data } },
    })
  },

  getTypeaheadUsers() {
    const url = Silverfin.Routes.typeahead_users_company_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId
    )

    return SFetch.json(url, { method: 'GET' })
  },

  getTypeaheadGroups() {
    const url = Silverfin.Routes.typeahead_groups_company_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId
    )

    return SFetch.json(url, { method: 'GET' })
  },

  deleteUserRole(id) {
    const url = Silverfin.Routes.company_user_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      id
    )

    return SFetch.json(url, { method: 'DELETE' })
  },

  companyToggleVisibility() {
    const url = Silverfin.Routes.toggle_company_visibility_company_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId
    )

    return SFetch.json(url, { method: 'PATCH' })
  },

  deleteGroup(id) {
    const url = Silverfin.Routes.delete_group_company_users_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId,
      { group_id: id }
    )

    return SFetch.json(url, { method: 'DELETE' })
  },

  createGroup(id) {
    const url = Silverfin.Routes.add_group_company_users_path(
      Silverfin.currentFirmId,
      Silverfin.currentCompanyId
    )

    return SFetch.json(url, {
      method: 'POST',
      body: { groupId: id },
    })
  },
}
